var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$can('manage', 'gateway'))?_c('main-content',{attrs:{"with_go_back_bar":""}},[_c('corporate-form',{attrs:{"submit":_vm.addCorporate,"form_data":_vm.corporate}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }